// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ol-layers-control {
    right: 0.5em;
    top: 2.5em;
    background-color: rgba(255,255,255,0.6);
}

.ol-layers-control:hover {
    background-color: rgba(255,255,255,0.9);
}

.ol-layers-control label {
    margin-left: 0.25em;
}

.ol-layers-control>div {
    padding: 0.25em;
}

.ol-layers-control>span>*:first-child {
    margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./node_modules/rlayers/dist/control/layers.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".ol-layers-control {\n    right: 0.5em;\n    top: 2.5em;\n    background-color: rgba(255,255,255,0.6);\n}\n\n.ol-layers-control:hover {\n    background-color: rgba(255,255,255,0.9);\n}\n\n.ol-layers-control label {\n    margin-left: 0.25em;\n}\n\n.ol-layers-control>div {\n    padding: 0.25em;\n}\n\n.ol-layers-control>span>*:first-child {\n    margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
